<template>
	<Scroller id="global" ref="mainScroller" :main="true">
		<NuxtPage />
	</Scroller>

	<Menu v-if="data" v-bind="data" />
	<Typeform />

	<PreLoader :title="`${SITE_NAME} — ${SITE_DESCRIPTION}`" />

	<Grid />
</template>

<script setup>
import { SITE_NAME, SITE_DESCRIPTION } from './config/site'
import { Grid, Scroller, PreLoader } from '@/components/core'
import { Typeform } from '@/components/fragments'

import { menu } from './sanity/projections'
import { Menu } from '@/components/navigation'

import { useScreen } from 'vue-screen'
import { breakpoints } from './config'

const mainScroller = ref(null)

const screen = useScreen()
const isMobile = ref(null)

const query = menu()
const { data } = await usePreviewSanityQuery(query)

onMounted(() => {
	nextTick(() => {
		isMobile.value = screen.width < breakpoints.small
	})
})

watch(
	() => screen?.width,
	(width) => {
		isMobile.value = width < breakpoints.small
	}
)

provide('$scroller', mainScroller)
</script>

<style lang="scss" scoped>
[data-component='pre-loader'] {
	--preload-color: var(--color-geral-white);
}
</style>
